import { createContext } from 'react';
/**
 * 选择状态管理器
 */
export const SelectStore = createContext<{
    state,
    dispatch: (payload: { [index: string]: any }) => void,
}>(null);